import './FormDatePicker.scss';

import React, { useContext, useRef } from 'react'
import { useFormContext, Controller } from 'react-hook-form';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import FormLabel from 'react-bootstrap/FormLabel';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { CustomPicker } from './CustomPicker';
import { NCRContext } from "views";
import { get, set } from "lodash";

const FormDatePicker = ({ name, label, disabled, future_date, past_date, showTime, callBackFunction, required }) => {

  const { state, setState } = useContext(NCRContext);
  const { control, errors } = useFormContext();

  const defaultValue = get(state, name);
  const defaultError = get(errors, name);
  const defaultCallback = (value) => setState(state => ({ ...set(state, name, value) }));

  const selectedDate = defaultValue ? new Date(defaultValue) : '';
  const callback = callBackFunction || defaultCallback;

  const dateRef = useRef();

  return (
    <>
      <Row className={'mb-2'}>
        <Col className={'my-auto'}>
          <FormLabel className={'w-100 my-auto'}>{`${label}:`}</FormLabel>
        </Col>
        <Col>
          <Controller
            name={name}
            defaultValue={selectedDate}
            control={control}
            rules={{ required: required }}
            onFocus={() => dateRef.current.focus()}
            render={({ onChange, value }) => (
              <DatePicker
                name={name}
                disabled={disabled}
                selected={selectedDate}
                onChange={onChange}
                onCalendarClose={() => callback(value, name)}
                maxDate={future_date || new Date()}
                minDate={past_date || new Date()}
                wrapperClassName='date-picker'
                dateFormat={showTime ? 'dd/MM/yyyy HH:mm:ss' : 'dd/MM/yyyy'}
                ref={ref => (dateRef.current = ref)}
                customInput={
                  <CustomPicker
                    name={name}
                    value={selectedDate}
                    disabled={disabled}
                    error={defaultError}
                  />
                }
              />
            )}
          />
        </Col>
      </Row>
    </>
  )
}

export { FormDatePicker };
